import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Principal } from '../../../../shared';
import { StudyEntrySearchParams, StudyEntryService } from '../../../../shared/study/service/study-entry.service';
import { DatasetService } from '../../../../shared/dataset/service/dataset.service';
import { ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS, MODIFY_COLUMNS_PERMISSIONS, VIEW_GERMPLASM_DETAILS_PERMISSION } from '../../../../shared/auth/permissions';
import { StudyEditorContext } from '../../../study-editor.context';
import { NgbActiveModal, NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../../../shared/alert/alert.service';
import { SearchComposite } from '../../../../shared/model/search-composite';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfirmComponent } from '../../../../shared/modal/modal-confirm.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { COLUMN_SELECTOR_CHECKBOX_ID } from '../../../tabs/dataset/column-selector/column-selector.component';
import { StudyEntryModel } from '../../../../shared/study/model/study-entry.model';
import { CellData, EditingDataMap } from '../../study-inline-editor/study-inline-editor.component';
import { StudyEntryPropertyData } from '../../../../shared/study/model/study-entry-property-data.model';
import { ColumnData } from '../../models/column-data.model';
import { ColumnDataService } from '../../services/column-data.service';
import { BreedingMethodModalService } from '../../../../shared/breeding-method/service/breeding-method-modal.service';
import { StudyEntryObservationService } from '../../../../shared/study/service/study-entry-observation';
import { ParamContext } from '../../../../shared/service/param.context';
import { InventoryDetailsPopupService } from '../../../../germplasm-manager/inventory/details/inventory-details-popup.service';
import { StudyEntryFilter, StudyEntryRequestModel } from '../../../../shared/study/model/study-entry-request.model';
import { DateFormatEnum, formatDate } from '../../../../shared/util/date-utils';
import { ObservationVariable } from '../../../../shared/model/observation-variable.model';
import { VariableTypeEnum } from '../../../../shared/ontology/variable-type.enum';
import { DataTypeEnum } from '../../../../shared/ontology/data-type.enum';
import { GermplasmDetailsUrlService } from '../../../../shared/germplasm/service/germplasm-details.url.service';
import { MAX_NAME_DISPLAY_SIZE } from '../../../../app.constants';
import { getStaticColumnLabelKey } from '../../../../shared/util/static-columns-util';

@Component({
    selector: 'jhi-change-plot-entry-modal',
    templateUrl: './change-plot-entry-modal.component.html',
    styleUrl: './change-plot-entry-modal.component.scss'
})
export class ChangePlotEntryModalComponent implements OnInit {

    constructor(
        private studyEntryService: StudyEntryService,
        private breedingMethodModalService: BreedingMethodModalService,
        public studyEditorContext: StudyEditorContext,
        public principal: Principal,
        private datasetService: DatasetService,
        private modalService: NgbModal,
        private studyEntryObservationService: StudyEntryObservationService,
        private alertService: AlertService,
        public paramContext: ParamContext,
        private activeModal: NgbActiveModal,
        protected germplasmDetailsUrlService: GermplasmDetailsUrlService,
        protected inventoryDetailsPopupService: InventoryDetailsPopupService,
        private translateService: TranslateService
    ) {
    }

  @Input() searchComposite: SearchComposite<any, number>;
  @Input() datasetId: number;

  protected readonly ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS = ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS;
  readonly MODIFY_COLUMNS_PERMISSIONS =  MODIFY_COLUMNS_PERMISSIONS;

  readonly MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
  readonly VariableTypeEnum = VariableTypeEnum;
  readonly DataTypeEnum = DataTypeEnum;
  readonly Math = Math;

  readonly ENTRY_TYPE = 8255;
  readonly ENTRY_NO = 8230;
  readonly GUID = 8235;
  readonly GROUPGID = 8330;
  readonly CROSS = 8377;
  readonly BREEDING_METHOD_ABBR = 8254;
  readonly MALE_PARENT_GID = 8345;
  readonly MALE_PARENT_NAME = 8346;
  readonly FEMALE_PARENT_GID = 8342;
  readonly FEMALE_PARENT_NAME = 8343;
  readonly GID = 8240;
  readonly DESIGNATION = 8250;
  readonly RADIO = COLUMN_SELECTOR_CHECKBOX_ID;
  readonly AVAILABLE = -4;
  readonly UNIT = -5;
  readonly ACTIVE_LOT = -3;

  readonly CREATE_STUDY_ENTRY_DETAILS_REQUIRED_FIELDS = [this.ENTRY_NO, this.ENTRY_TYPE];

    @ViewChild('p', { static: false }) columnFilterPopover: NgbPopover;

    hasViewGermplasmDetailsPermission: boolean;

    entries: StudyEntryModel[] = [];
    editingData: EditingDataMap<StudyEntryPropertyData> = {};
    editingCell: CellData<StudyEntryPropertyData | null>;

    entryDetailVariables: ColumnData[] = [];
    selectedItem: number;
    numberOfEntries = 0;
    numberOfFilteredEntries = 0;
    showStudyEntriesTable = true;
    isCategoricalDescriptionView = false;

    germplasmDescriptorColumns: ColumnData[] = [];
    passportColumns: ColumnData[] = [];
    attributesColumns: ColumnData[] = [];
    namesColumns: ColumnData[] = [];
    displayedColumns: ColumnData[] = [];
    studyEntryColumnsTermIds: number[];

    currentPage = 1;
    pageSize = 50;

    activePopover?: NgbPopover;
    columnDataForFilter: ColumnData;
    columnDataService: ColumnDataService;

    isLoading = false;

    isReloadPending: boolean;
    reloadDelay: number = 800;
    reloadTimeout: any;

    isTableDataReloadPending: boolean;
    tableDataReloadTimeout: any;

    isSaveEntryTableColumnsPending: boolean;
    saveEntryTableColumnsTimeout: any;

    numberOfInstances: number;
    numberOfPlots: number;

    ngOnInit(): void {

        this.columnDataService = new ColumnDataService(ColumnDataService.CHANGE_PLOT_ENTRY_KEY, String(this.studyEditorContext.studyId));
        // Delete the columns state when this modal is opened to prevent loading old columns state,
        this.columnDataService.deleteColumnsStateForCurrentKey();

        this.hasViewGermplasmDetailsPermission = this.principal.hasAnyAuthorityDirect(VIEW_GERMPLASM_DETAILS_PERMISSION);
        this.loadTable();

        this.datasetService.getObservationUnitsMetadata(this.searchComposite, this.studyEditorContext.studyId, this.datasetId).toPromise().then((response)=> {
            this.numberOfPlots = response.observationUnitsCount;
            this.numberOfInstances = response.instancesCount;
        });
    }


    confirm() {
        this.proceed().then(() => {
            const observationUnitEntryReplaceRequest = {
                searchRequest: this.searchComposite,
                entryId: this.selectedItem
            };
            this.datasetService.updateObservationUnitsEntry(observationUnitEntryReplaceRequest, this.studyEditorContext.studyId, this.datasetId).toPromise().then(() => {
                this.activeModal.close();
                this.alertService.success('study-editor.change-plot-entry-modal.change-entry-success');
            });
        });
    };

    cancel() {
        this.activeModal.dismiss();
    };

    valid() {
        return this.selectedItem !== undefined && this.selectedItem !== null && this.numberOfPlots > 0 && this.numberOfInstances > 0;
    };

    proceed() {
        const confirmModalRef = this.modalService.open(ModalConfirmComponent, {});
        confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.change-plot-entry-modal.changing.plot.entry.warning');
        return confirmModalRef.result;
    }

    /**
     * Efficiently reload table
     */
    scheduleReload(): void {
        if (this.isReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.reloadTimeout);
        } else {
            this.isReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.reloadTimeout = setTimeout(() => {
            this.loadTable();
            this.isReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    /**
     * Efficiently reload table data
     */
    scheduleTableDataReload(pageIndex, pageSize): void {
        if (this.isTableDataReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.tableDataReloadTimeout);
        } else {
            this.isTableDataReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.tableDataReloadTimeout = setTimeout(() => {
            this.loadTableData(pageIndex, pageSize);
            this.isTableDataReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    loadTable(): void {
        this.isLoading = true;
        this.loadTableHeader().then(() => {
            this.loadTableData();
        });
    }

    loadTableHeader(): Promise<void> {
        return this.studyEntryService.getEntryTableColumns(this.studyEditorContext.studyDetails.id).toPromise().then(async (columns) => {
            const columnsFromResponse: ColumnData[] = columns.map(column => column as ColumnData);
            columnsFromResponse.forEach(column => {
                column.visible = true;
                column.selected = true;
                column.columnSelectorVisible = true;
            });
            columnsFromResponse.unshift({
                alias: '',
                factor: true,
                name: '',
                termId: this.RADIO,
                displayName: '',
                visible: true,
                columnSelectorVisible: false,
                selected: true,
                variableTypeId: 0,
                id: 0,
                possibleValuesById: undefined,
                possibleValuesByName: undefined,
                enableFilterSorting: false,
                deletable: false,
                hidden: false,
                inputVariables: ''
            });

            this.displayedColumns = this.columnDataService.processColumns(columnsFromResponse, this.displayedColumns);
            this.groupColumns(this.displayedColumns);

            if (this.displayedColumns.every(column => column.sortingAsc === undefined)) {
                const entryNoColumn = this.displayedColumns.find(column => column.termId === this.ENTRY_NO);
                if (entryNoColumn) {
                    entryNoColumn.sortingAsc = true;
                }
            };
        });
    }

    loadTableData(pageIndex = 0, pageSize = 50): void {
        const filter = this.getFilter();
        const searchData: StudyEntryRequestModel = {
            studyId: this.studyEditorContext.studyDetails.id,
            filter: filter
        };

        const searchParams: StudyEntrySearchParams = {
            page: pageIndex,
            size: pageSize,
            sort: this.getSort(),
            searchDTO: searchData,
            germplasmDescriptorIds: []
        };

        this.studyEntryService.getStudyEntries(this.studyEditorContext.studyDetails.id, searchParams).toPromise().then(
            (paginatedResponse) => {
                this.entries = paginatedResponse.data;
                this.numberOfEntries = paginatedResponse.totalCount;
                this.numberOfFilteredEntries = paginatedResponse.filteredCount;
                this.studyEditorContext.germplasmListExists = this.numberOfEntries > 0;
                this.studyEditorContext.studyDetails.numberOfEntries = this.numberOfEntries;
                this.isLoading = false;
            }).finally(() => {
            this.isLoading = false;
        });
    }

    private groupColumns(columnsData: ColumnData[]): void {

        this.germplasmDescriptorColumns = [];
        this.passportColumns = [];
        this.attributesColumns = [];
        this.namesColumns = [];
        this.entryDetailVariables = [];

        columnsData.forEach(column => {
            if (column.variableTypeId === VariableTypeEnum.GERMPLASM_DESCRIPTOR) {
                this.germplasmDescriptorColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.GERMPLASM_PASSPORT) {
                this.passportColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.GERMPLASM_ATTRIBUTE) {
                this.attributesColumns.push(column);
            } else if (column.variableTypeId === null && column.termId > 0) {
                this.namesColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.ENTRY_DETAIL) {
                this.entryDetailVariables.push(column);
            }
        });
    }

    toggleSelect($event, index: number, studyEntryModel: StudyEntryModel, checkbox = false) {
        this.selectedItem = studyEntryModel.entryId;
    }

    isSelected(entryId: number): boolean {
        return this.selectedItem === entryId;
    }

    getFilter(): StudyEntryFilter {
        return {
            entryNumbers: [],
            entryIds: [],
            filteredValues: this.displayedColumns.reduce((map, column) => {
                column.isFiltered = false;

                if (this.isTextFilter(column)) {
                    return map;
                }

                if (column.possibleValues) {
                    const selectedValues = column.possibleValues
                        .filter(value => value.isSelectedInFilters)
                        .map(value => value.name);

                    if (selectedValues.length > 0) {
                        map[column.termId] = selectedValues;
                        column.isFiltered = true;
                    } else if (column.query) {
                        map[column.termId] = [column.query];
                        column.isFiltered = true;
                    }
                } else if (column.query) {
                    if (column.dataType === 'Date') {
                        map[String(column.termId)] = [formatDate(column.query, DateFormatEnum.ISO_8601_BASIC)];
                    } else {
                        map[String(column.termId)] = [column.query];
                    }
                }

                return map;
            }, {} as Map<string, string[]>),
            filteredTextValues: this.displayedColumns.reduce((map, column) => {
                if (!this.isTextFilter(column)) {
                    return map;
                }
                if (column.query) {
                    map[column.termId] = column.query;
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string>),
            variableTypeMap: this.displayedColumns.reduce((map, column) => {
                map[column.termId] = column.variableType;
                return map;
            }, {} as Map<string, string>),
            preFilteredGids: []
        };
    }

    isTextFilter(column: ColumnData): boolean {
        // Factors like GID, GROUPGID have 'Germplasm List' datatype but they should be treated as numeric
        if (column.termId === this.GID || column.termId === this.GROUPGID) {
            return false;
        }

        // FEMALE_PARENR_GID and FEMALE_PARENT_GID are also numeric but should be treated as text
        if (column.termId === this.FEMALE_PARENT_GID || column.termId === this.MALE_PARENT_GID ||
            column.termId === this.FEMALE_PARENT_NAME || column.termId === this.MALE_PARENT_NAME) {
            return true;
        }

        if (column.dataTypeCode === 'C' || column.dataTypeCode === 'N'
            || column.dataTypeCode === 'D') {
            return false;
        }

        return true;
    }

    hasAnyAuthority(permissions: string[]): boolean {
        return this.principal.hasAnyAuthorityDirect(permissions);
    }

    openBreedingMethodModal(methodId: number): void {
        this.breedingMethodModalService.openBreedingMethodModal(methodId, null);
    }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.scheduleTableDataReload((page - 1), this.pageSize);
    }

    onSelectAll(column: ColumnData): void {
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = column.isSelectAll;
            });
        }
    }

    onSelectOption(column: ColumnData, option: any): void {
        if (!option.isSelectedInFilters) {
            column.isSelectAll = false;
        }
    }

    getFilteredOptions(column: ColumnData): any[] {
        if (!column.possibleValues) {
            return [];
        }
        return column.possibleValues.filter(option => {
            if (!column.query) {
                return true;
            }
            return option.name.toLowerCase().includes(column.query.toLowerCase());
        });
    }

    resetFilter(column: ColumnData): void {
        this.clearSelectedItem();
        column.query = '';
        column.sortingAsc = null;
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = false;
            });
            column.isSelectAll = false;
        }
        this.scheduleTableDataReload(0, this.pageSize);
    }

    getCellClass(entry: StudyEntryModel, column: ColumnData): string {
        const property = entry.properties[column.termId];
        if (!property) {
            return '';
        }

        const classes = ['entry-details'];

        if (property.status === 'MANUALLY_EDITED') {
            classes.push('manually-edited-value');
        } else if (property.status === 'OUT_OF_SYNC') {
            classes.push('out-of-sync-value');
        }

        return classes.join(' ');
    }

    getCellValue(entry: StudyEntryModel, column: ColumnData): string {
        if (!entry?.properties || !column?.termId) {
            return '';
        }

        const property = entry.properties[column.termId];
        if (!property?.value) {
            return '';
        }

        return property.value;
    }

    async resetEntryTableColumns(): Promise<void> {

        this.displayedColumns.forEach(column => {
            column.selected = true;
            column.visible = true;
        });

        this.scheduleReload();
    }

    toggleShowCategoricalDescription(): void {
        this.isCategoricalDescriptionView = !this.isCategoricalDescriptionView;
    }

    resetStudyEntries(): void {
        // Implement clear list functionality
    }

    getColumnClass(column: ColumnData) {
        let className = 'default ';
        return className;
    }

    checkVariableHasMeasurementData(deleteVariables: ObservationVariable[]): Promise<boolean> {
        if (deleteVariables.length === 0) {
            return Promise.resolve(false); // No variables to delete, return false
        }

        const variablesToDelete: number[] = deleteVariables.map(variable => variable.termId);

        // Asynchronous process to check the count of observations
        return this.studyEntryObservationService.countObservationsByVariables(this.studyEditorContext.studyDetails.id, variablesToDelete)
            .toPromise()
            .then(response => {
                const count = parseInt(response.headers.get('X-Total-Count'), 10); // First check the count
                if (count > 0) {
                    // Show confirmation modal and handle user choice
                    const modalRef = this.modalService.open(ModalConfirmComponent);
                    modalRef.componentInstance.title = 'Confirmation';
                    modalRef.componentInstance.message = 'This variable contains observation data that will be lost if you remove it. Please confirm that you want to remove it.';

                    return modalRef.result
                        .then(() => true) // User confirms (true)
                        .catch(() => false); // User cancels (false)
                } else {
                    // No observations, resolve as true
                    return true;
                }
            })
            .catch(error => {
                console.error('Error checking variable measurement data:', error);
                return true; // Handle error case, return true as a fallback
            });
    }

    getSort(): string {

        const sort = this.displayedColumns.reduce((sort, column) => {
            if (column.sortingAsc !== null && column.sortingAsc !== undefined) {
                return column.termId + ',' + (column.sortingAsc ? 'asc' : 'desc');
            }
            return sort;
        }, '');

        return sort;
    }

    sortColumn(column: ColumnData, ascending: boolean): void {

        // Clear sorting state for all displayed columns to ensure only one column can be sorted at a time
        this.resetSortingsOfDisplayedColumns();

        column.sortingAsc = ascending;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    filterByColumn(column: ColumnData) {
        this.clearSelectedItem();
        column.isFiltered = true;
        this.columnFilterPopover.close();
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetFilterByColumn(column: ColumnData) {
        column.isFiltered = false;
        column.query = '';
        column.sortingAsc = null;
        column.possibleValues?.forEach(value => {
            value.isSelectedInFilters = false;
        });
        column.isSelectAll = false;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetSortingsOfDisplayedColumns() {
        this.displayedColumns.forEach(column => {
            column.sortingAsc = null;
        });
    }

    filterSelectAll(column: ColumnData, isSelectAll: boolean) {
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = isSelectAll;
            });
        }
    }

    filterSelectOption(isSelectedInFilters: any) {

    }

    showColumnFilterPopover(column: ColumnData, p: NgbPopover) {
        this.columnDataForFilter = column;
        p.open({
            column: column
        });
    }

    onPageSizeChange($event: Event) {
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    areColumnsVisible(columns: ColumnData[]): boolean {
        return columns.filter((column) => column.visible).length > 0;
    }

    getCellData(row: number, col: number): CellData<StudyEntryPropertyData> | null {
        try {
            // Input validation
            if (row < 0 || col < 0) {
                return null;
            }

            // Check if row exists
            const rowData = this.editingData[row];
            if (!rowData) {
                return null;
            }

            // Check if cell exists in row
            const cellData = rowData[col];
            if (!cellData) {
                return null;
            }

            return cellData;
        } catch (error) {
            console.error(`Error getting cell data for row ${row}, col ${col}:`, error);
            return null;
        }
    }

    // Helper method to set cell data
    setCellData(row: number, col: number, data: Partial<CellData<StudyEntryPropertyData>>): void {
        if (!this.editingData[row]) {
            this.editingData[row] = {};
        }

        this.editingData[row][col] = {
            ...this.editingData[row][col],
            ...data,
            row,
            col
        };
    }

    // Helper method to check if cell exists
    hasCellData(row: number, col: number): boolean {
        return !!(this.editingData[row]?.[col]);
    }

    // Helper method to clear cell data
    clearCellData(row: number, col: number): void {
        if (this.editingData[row]) {
            delete this.editingData[row][col];

            // Clean up empty rows
            if (Object.keys(this.editingData[row]).length === 0) {
                delete this.editingData[row];
            }
        }
    }

    variableDataTypeIs(variable: ColumnData, type: DataTypeEnum): boolean {
        if (variable.variableType && variable.variableType.toString() === VariableTypeEnum[VariableTypeEnum.STUDY_DETAIL]) {
            return variable.dataType && variable.dataType.valueOf() === DataTypeEnum[type];
        }
        return false;
    }

    trackRowsById(studyEntryModel: StudyEntryModel) {
        return studyEntryModel.guid;
    }

    trackColumnsById(column: ColumnData) {
        return column.id;
    }

    openGermplasmDetailsAsNewTab(gid: number) {
        const url = this.germplasmDetailsUrlService.getUrlAsString(gid);
        window.open(url, '_blank');
    }

    openInventoryDetails(gid: number) {
        this.inventoryDetailsPopupService.open(gid);
    }

    handleContextMenu(event: MouseEvent) {
        // Check if the right-click originated from an input or its label
        if (event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLLabelElement ||
            (event.target instanceof HTMLElement && event.target.closest('input'))) {
            // Allow default context menu for inputs
            return;
        }

        // Prevent default context menu for the rest of the row
        event.preventDefault();

    }

    dropColumn(event: CdkDragDrop<any[]>) {
        // Get indexes of selected columns only
        const selectedColumns = this.displayedColumns.filter(col => col.selected);
        const fromIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.previousIndex]);
        const toIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.currentIndex]);

        if (fromIndex !== -1 && toIndex !== -1) {
            moveItemInArray(this.displayedColumns, fromIndex, toIndex);
            this.columnDataService.saveColumnsState();
        }
    }

    onColumnSelectoChange(column: ColumnData) {
        if (column) {
            column.visible = column.selected;
        }
    }

    onColumnSelectorReset() {
        this.resetEntryTableColumns();
    }

    clearFilters() {
        this.displayedColumns.forEach(column => {
            this.resetFilter(column);
        });
    }

    clearSelectedItem() {
        this.selectedItem = null;
    }


    protected readonly getStaticColumnLabelKey = getStaticColumnLabelKey;
}
